import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const ValentinesFaq = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px', color: '#FFFFFF' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
        <button className="back-button" onClick={() => navigate('/home')}>
          <FiChevronLeft className="back-button-icon" />
        </button>
        <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 700, marginLeft: '20px' }}>
          FAQ
        </div>
      </div>
      <div>
        <ul className="mt-4">
          <li>
            <p className="FAQ-Question">What is the Holi Campaign on GoSats?</p>
            <p className="paragraph">
            GoSats is celebrating Holi with exciting rewards, festive offers, and a brand-new Spinning Wheel feature in the app. The campaign is designed to make your Holi more rewarding with instant prizes, card benefits, and exclusive discounts.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">When is the Holi Campaign applicable?</p>
            <p className="paragraph">
            The Holi Campaign is valid for a limited festive period starting 3rd of March 8:00 AM till 5th of March 11:59 PM.
            </p>
          </li>
          <li>
            <p className='FAQ-Question'>What are eligible card spends?</p>
            <p className='paragraph'>Most regular purchases qualify. Excluded categories include Fastag Recharge, Indian Railways, Bill/Utility Payments, Digital Wallet Loads, Real Estate, and more as listed in the T&C.</p>
          </li>
          {/* <li>
            <p className="FAQ-Question">What is the Loyalty Bonus?</p>
            <p className="paragraph">
            The Loyalty Bonus is a special Anniversary reward in sats given to users as a thank-you for being active on GoSats.
            </p>
          </li> */}
          <li>
            <p className='FAQ-Question'>Are there any ineligible transaction categories for the 3% rewards on Elite Card Spends?</p>
            <p className='paragraph'>Yes, transactions in Fastag Recharge, Indian Railways, Bill/Utility Payments, Digital Wallet Loads, Real Estate, Government services, Telecommunications, Gift, Novelty, and Souvenir Shops, Insurance, Quasi Cash, Fuel, Rent/Education, Toll, Bridge, Discount Stores and card spends on Voucher Purchases, SatsPay, BBPS and Gold Investments are excluded.</p>
          </li>
          <li>
            <p className="FAQ-Question">
              What card spend offers are available during the Holi Campaign?</p>
            <p className="paragraph">
            Earn up to 3% Bitcoin rewards on every eligible Elite card spend. 1% rewards are withdrawable on the Bitcoin blockchain, 2% can be used for redemptions within the GoSats app.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What’s new for users? </p>
            <p className="paragraph">
            The Spinning Wheel is reformed where users can spin and win new exciting rewards during the Holi campaign. Rewards may include sats, cashback, vouchers, or other festive benefits.
            </p>
          </li>
          {/* <li>
            <p className="FAQ-Question">
            What is the voucher offer during the Anniversary Campaign?</p>
            <p className="paragraph">
            During the period of campaign, you can earn 500 sats when you purchase 5 vouchers.
            </p>
            <ul>
              <li>
                <p className="paragraph">
                The reward is applicable only if minimum value of ₹300 is spent on 5 voucher.
                </p>
              </li>
              <li>
                <p className="paragraph">
                Purchases of fewer than 5 vouchers are not eligible
                </p>
              </li>
              <li>
                <p className="paragraph">
                  Amazon pay and Phonepe vouchers are not eligible for the voucher reward.
                </p>
              </li>
            </ul>
          </li> */}
          <li>
            <p className="FAQ-Question">
            What if I don’t receive my Holi rewards?</p>
            <p className="paragraph">
              Please contact in-app support or write to support@gosats.io from your registered email ID for assistance.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ValentinesFaq;
